import axiosInstance from "./axiosInstance";



export const balanceEnquiry = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/aeps/balance-enquiry", payload, {
      timeout: 180000,
    });

    return res.data; // 🔥 direct backend response return
  } catch (err) {
    return {
      success: false,
      message:
        err.response?.data?.message ||
        err.response?.data?.data?.message ||
        "AEPS request failed",
      code: err.response?.data?.code || 0,
    };
  }
};

export const merchantActiveBanks = async () => {
  try {
    const res = await axiosInstance.get("/api/aeps/merchant-banks");

    return res.data; // 🔥 direct backend response return
  } catch (err) {
    return {
      success: false,
      message:
        err.response?.data?.message ||
        err.response?.data?.data?.message ||
        "AEPS request failed",
      code: err.response?.data?.code || 0,
    };
  }
};


export const aepsTxnList = async (params={}) => {
  try {
    const res = await axiosInstance.get(
      "/api/aeps/aeps/transaction_list",{
        params:params
      }
);

    return {
      success: true,
      data: res.data?.data,
      message: res.data?.message || "Balance fetched successfully",
      code: res.data?.code || 1,
    };
  } catch (err) {
    return {
      success: false,
      code: err.response?.data?.code || 0,
      message:
        err.response?.data?.message ||
        "AEPS request failed. Please try again",
    };
  }
};


export const aepsAuthanticateCheck = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/api/aeps/auth-enquiry",
      payload,
      {
        timeout: 180000, // 180 sec as per AEPS spec
      }
    );

    return {
      success: true,
      data: res.data?.data,
      message: res.data?.message || "Balance fetched successfully",
      code: res.data?.code || 1,
    };
  } catch (err) {
    return {
      success: false,
      code: err.response?.data?.code || 0,
      message:
        err.response?.data?.message ||
        "AEPS request failed. Please try again",
    };
  }
};


export const cashWithdrawal  = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/aeps/cash-withdrawal`,data);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  }  catch (err) {
    return {
      success: false,
      message:
        err.response?.data?.message ||
        err.response?.data?.data?.message ||
        "AEPS request failed",
      code: err.response?.data?.code || 0,
    };
  }
};

export const miniStatement  = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/aeps/mini-statement`,data);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const aadhaarPay  = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/aeps/aadhaar-pay`,data);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const statusCheck  = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/aeps/status-check`,data);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const statusCheckAepsAccount = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/api/paysprint/onboard/merchant-status-check`,
      data
    );
    return {
      success: response?.data?.status,
      data: response?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    return {
      success: false,
      data: null,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};



export const getAepsOnboardAccount  = async () => {
  try {
    const response = await axiosInstance.get(`/api/aeps/onboard/merchant-onboard`);
    return response.data
  } catch (err) {
    return {
      success: false,
      code: err.response?.data?.code || 0,
      message: err.response?.data?.message || "AEPS Activation Failed",
    };
  }
};

export const merchantAuthCheckDaily = async (data) => {
  try {
    const res = await axiosInstance.post(
      "/api/paysprint/onboard/aeps/2fa-registration",
      data
    );

    return {
      success: res.data.success,
      data: res.data.data,
      message: res.data.message,
    };
  } catch (error) {
    console.error("Two Factor API Error:", error.response?.data);

    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Two Factor Registration Failed",
      status: error.response?.status,
    };
  }
};

export const startMerchantKyc = async (merchantId) => {
  try {
   const response = await axiosInstance.post("/api/paysprint/onboard/url", 
    merchantId,
  );

      return response.data
  } catch (err) {
    return {
      success: false,
      code: err.response?.data?.code || 0,
      message: err.response?.data?.message || "AEPS Activation Failed",
    };
  }
};

export const merchantRegistrationAuth = async (data) => {
  try {
    const res = await axiosInstance.post(
      "/api/aeps/status-check/daily-auth-check",
      data
    );

    return {
      success: res.data.success,
      data: res.data.data,
      message: res.data.message,
    };
  } catch (error) {
    console.error("Two Factor API Error:", error.response?.data);

    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Two Factor Registration Failed",
      status: error.response?.status,
    };
  }
};
export const merchantDailyAuthCheck = async (data) => {
  try {
    const res = await axiosInstance.post(
      "/api/paysprint/onboard/aeps/daily-auth-check",
      data
    );

    return res.data; // 🔥 return full backend response
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Daily Auth Failed",
      status: error.response?.status,
      data: error.response?.data,
    };
  }
};


export const merchantRegistrationEkyc = async (data) => {
  try {
    const res = await axiosInstance.post("/api/paysprint/onboard/aeps/2fa-registration", data);

    return res.data; // return full backend response
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Server Error",
      status: error.response?.status,
      data: error.response?.data,
    };
  }
};



export const aepsFrBankList  = async (data) => {
  try {
    const response = await axiosInstance.get(`/api/aeps/bank-list`,data);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const TransferAepsToMainWallet = async (amount) => {
  try {
    const response = await axiosInstance.post(`/api/aeps/transaction/aeps-to-main`, amount);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};



export const aepsRegistration = async (data) => {
  try {
    const res = await axiosInstance.post(
      "/api/paysprint/aeps/registration-kyc/otp",
      data
    );

    return {
      success: res.data.success,
      data: res.data.data,
      message: res.data.message,
    };

  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || "Server error",
    };
  }
};



export const aepsRegistrationVerify = async (amount) => {
  try {
    const response = await axiosInstance.post(`/api/paysprint/aeps/registration-kyc/verifyotp`, amount);
    return response.data
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};




// ================= SEND OTP (BANK3) =================
export const sendAepsOtpMerchant = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/paysprint/merchant/send-otp",payload);

    return res.data
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || "OTP Send Failed",
    };
  }
};

// ================= VERIFY OTP (BANK3) =================
export const verifyAepsOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/paysprint/merchant/verify-otp", payload);

    return {
      success: res.data.success,
      data: res.data,
      message: res.data.message || "OTP Verified",
    };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || "OTP Verification Failed",
    };
  }
};

// ================= FINAL ACTIVATE AEPS (ALL BANKS) =================
export const activateAeps = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/paysprint/merchant/activate", payload, {
      timeout: 180000,
    });

   return res.data
  } catch (err) {
    return {
      success: false,
      code: err.response?.data?.code || 0,
      message: err.response?.data?.message || "AEPS Activation Failed",
    };
  }
};






